<template>
  <div>
    <!-- Loading Screen -->
    <transition name="fade">
      <div class="loading-screen" v-if="isLoading">
        <div class="logo-container">
          <img src="../assets/logo.png" alt="Logo" class="logo animate-logo">
        </div>
      </div>
    </transition>

    <!-- Original Content -->
    <div v-show="!isLoading" class="fade-in">
      <!-- Back to Top Button -->
      <transition name="fade-slide">
        <div class="backtop-container" @click="scrollToTop" v-show="showBackTop">
          <div class="backtop-button">
            <i class="fa-solid fa-arrow-up"></i>
          </div>
        </div>
      </transition>

      <!-- WhatsApp Button -->
      <div class="whatsapp-container">
        <a href="https://api.whatsapp.com/send?phone=963987292450" class="float" target="_blank">
          <i class="fa-brands fa-whatsapp my-float"></i>
        </a>
        <div class="wave-effect"></div>
        <div class="wave-effect wave-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsAppButton',
  data() {
    return {
      showBackTop: false,
      isLoading: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)

    setTimeout(() => {
      this.isLoading = false
    }, 5000)
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackTop = window.scrollY > 300
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.whatsapp-container {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 100;
}

.float {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #25d366;
  color: #FFF;
  border-radius: 50%;
  text-align: center;
  font-size: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 102;
}

.float:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

.my-float {
  margin: 0;
}

.wave-effect {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 0;
  left: 0;
  border-radius: 50%;
  background-color: #25d366;
  opacity: 0.6;
  z-index: 101;
  animation: wave 2s infinite;
}

.wave-2 {
  animation-delay: 8ms;
}

@keyframes wave {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }

  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

/* Back to Top Button Styles */
.backtop-container {
  position: fixed;
  bottom: 110px;
  right: 40px;
  z-index: 100;
  cursor: pointer;
}

.backtop-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #333;
  color: #FFF;
  border-radius: 50%;
  text-align: center;
  font-size: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.backtop-button:hover {
  transform: scale(1.1);
  background-color: #444;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.3);
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Fade-slide transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
}

/* Loading Screen Styles */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.logo-container {
  width: 250px;
  height: 250px;
}

.logo {
  width: 70%;
  height: 70%;
  object-fit: contain;
}

.animate-logo {
  animation: pulse 2s infinite;
}

.fade-in {
  animation: fadeIn 1s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Mobile optimization */
@media screen and (max-width: 768px) {
  .whatsapp-container {
    bottom: 20px;
    right: 20px;
  }

  .float {
    width: 50px;
    height: 50px;
    font-size: 25px;
  }

  .wave-effect {
    width: 50px;
    height: 50px;
  }

  .backtop-container {
    bottom: 90px;
    right: 20px;
  }

  .backtop-button {
    width: 50px;
    height: 50px;
    font-size: 25px;
  }
}
</style>